module.exports = __webpack_public_path__ + "static/media/goto_demo.e26aa66c.svg";